export const getBulkActionStatusBadgeColor = status => {
  switch (status) {
    case 'completed':
      return 'success';

    case 'scheduled':
      return 'warning';

    case 'failed':
      return 'danger';

    default:
      return 'secondary';
  }
};

export const getBulkActionTypeBadgeColor = type => {
  switch (type) {
    case 'order_cancel':
      return 'danger';

    case 'inventory_stock_add':
      return 'success';

    default:
      return 'secondary';
  }
};
